import { Combobox } from '@headlessui/react';
import { useState, useEffect } from 'react';
import axios from 'axios';

type Banco = {
  code: string;
  fullName: string;
};

interface Props {
  value: string; // o `code`
  onChange: (value: string) => void; // só o `code`
}

export default function AutocompleteBank({ value, onChange }: Props) {
  const [query, setQuery] = useState('');
  const [bancos, setBancos] = useState<Banco[]>([]);
  const [filtered, setFiltered] = useState<Banco[]>([]);

  useEffect(() => {
    axios
      .get('https://brasilapi.com.br/api/banks/v1')
      .then((res) => {
        const validos = res.data
          .filter((b: any) => b.code !== null && b.fullName)
          .map((b: any) => ({
            code: b.code.toString().padStart(3, '0'),
            fullName: b.fullName,
          }));
        setBancos(validos);
      })
      .catch(console.error);
  }, []);

  useEffect(() => {
    const q = query.toLowerCase();
    setFiltered(
      bancos.filter(
        (b) => b.fullName.toLowerCase().includes(q) || b.code.includes(q)
      )
    );
  }, [query, bancos]);

  const selectedBanco = bancos.find((b) => b.code === value);

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Banco
      </label>
      <Combobox value={value} onChange={onChange}>
        <div className="relative">
          <Combobox.Input
            className="w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:border-red-500 focus:outline-none focus:ring-1 focus:ring-red-500 sm:text-sm"
            onChange={(e) => setQuery(e.target.value)}
            displayValue={() =>
              selectedBanco
                ? `${selectedBanco.code} - ${selectedBanco.fullName}`
                : ''
            }
            placeholder="Digite o nome ou código"
          />
          <Combobox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
            {(filtered.length > 0 ? filtered : bancos).map((banco) => (
              <Combobox.Option
                key={banco.code}
                value={banco.code}
                className={({ active }) =>
                  `relative cursor-pointer select-none py-2 pl-3 pr-9 ${
                    active ? 'bg-red-100 text-red-900' : 'text-gray-900'
                  }`
                }
              >
                {`${banco.code} - ${banco.fullName}`}
              </Combobox.Option>
            ))}
          </Combobox.Options>
        </div>
      </Combobox>
    </div>
  );
}
